import { cva } from 'class-variance-authority';

const radioGroupLabelBaseStyles = [
  'cursor-pointer',
  'disabled:cursor-not-allowed',
  'text-sm',
  'select-none',
];

const radioGroupLabelStylesSAG = cva([
  ...radioGroupLabelBaseStyles,
  'text-[#000028]',

  // Dark mode
  'dark:text-[#FFFFFF]',
]);

const radioGroupLabelStylesSHS = cva([
  ...radioGroupLabelBaseStyles,
  'text-[#1A1A1A]',

  // Dark mode
  'dark:text-[#E6E6E6]',
]);

export { radioGroupLabelStylesSAG, radioGroupLabelStylesSHS };
